var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"input-text",class:{ 'input-text--disabled': _vm.isDisabled }},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('input',{attrs:{"type":"text","disabled":_vm.isDisabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }